import { BaseObject } from '../../../core/business-objects/base-object/base-object.model';
import { arrayPushUnique } from '../../../core/util/array-push-unique';
import { Control } from '../../../vas/business-objects/control/control.model';
import { Form } from '../../../vas/business-objects/form/form.model';
import { Group } from '../../../vas/business-objects/group/group.model';
import { ComplexControlConfig } from '../../../vas/controls/complex/complex-control-config.model';
import { ComplexControl } from '../../../vas/controls/complex/complex-control.model';
import * as actions from './form-manager-page.actions';
import { State } from './form-manager-page.reducer';

export class FormManagerPageReducerHelper {

    static arrayToState <T extends BaseObject>(list: Array<T>): {ids: Array<string>, entities: {[id: string]: T}} {
        const state = {
            ids: [],
            entities: {}
        };
        list.forEach(obj => {
            state.ids.push(obj.id);
            state.entities[obj.id] = obj;
        });
        return state;
    }

    static updateSubControl(control: ComplexControl, subControl: Control): Control {
        const newControl = new Control({
            ...control,
            config: new ComplexControlConfig({
                ...control.config,
                controls: [
                    ...(control.config.controls || []).filter(c => c.id !== subControl.id),
                    subControl
                ]
                    .sort((a, b) => a.sequence - b.sequence)
                    .map((c, sequence) => new Control({...c, sequence}))
            })
        });
        return newControl;
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/form-manager-page.reducer-helper.ts